import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Input,
  ModalFooter
} from 'reactstrap';
import CheckBox from '@componentes/checkbox/checkbox.component';
import * as commonActions from '@common/common.action';
import WebapiCommon from '@util/webapi.common';
import { getUsuarioLocalStorage } from '../../../../localStorage.util';
import './styles.css';
import { injectIntl } from 'react-intl';

function CheckUrgente ({ justificativaFixa, intl }) {
  const dispatch = useDispatch();
  const detalhes = useSelector(state => state.commonReducer.detalhes);
  const listagemState = useSelector(state => state.commonReducer.listagem);
  const [modalUrgente, setModalUrgente] = useState(false);
  const [justificativa, setJustificativa] = useState('');
  const { messages } = intl;

  const marcarUrgente = justificativa => {
    var urgente = detalhes.urgente ? false : true;
    dispatch(commonActions.showFadeCarregando(true));
    WebapiCommon.marcarLaudoUrgente(
      detalhes.laudo,
      urgente,
      justificativa
    ).then(() => {
      var detalhesUpdated = detalhes;
      detalhesUpdated.urgente = urgente;
      dispatch(commonActions.atualizarDetalhes(detalhesUpdated));
      setJustificativa('');
      setModalUrgente(false);

      let listagem = [...listagemState];
      const listagemIndex = listagem.findIndex(
        item => item.laudo === detalhesUpdated.laudo
      );
      listagem[listagemIndex] = detalhesUpdated;
      dispatch(commonActions.preencherListagem(listagem));
      dispatch(commonActions.showFadeCarregando(false));
      dispatch(
        commonActions.showAlerta(
          'sucesso',
          'Operação realizada com sucesso.',
          1500
        )
      );
    });
  };

  const toggle = () => setModalUrgente(!modalUrgente);

  const onClickCheck = () => {
    if (detalhes.mapaFinalizado) {
      dispatch(
        commonActions.showAlerta(
          'alerta',
          'Ação cancelada pois o mapa macroscópico está finalizado.',
          3000,
          '500px'
        )
      );
      return;
    }

    if (detalhes.entregue) {
      dispatch(
        commonActions.showAlerta(
          'alerta',
          'Ação cancelada pois o exame já foi entregue.',
          3000,
          '500px'
        )
      );
      return;
    }

    if (justificativaFixa) {
      const usuarioLocalStorage = getUsuarioLocalStorage();
      marcarUrgente(`${justificativaFixa} ${usuarioLocalStorage.usuario}`);
    } else {
      setModalUrgente(true);
    }
  };

  return (
    <div className='mv-checkbox-urgente-componente'>
      <div onClick={onClickCheck}>
        <CheckBox readOnly label={messages['dashboards.examDetails.urgent']} checked={detalhes.urgente}>
          <i className='fas fa-exclamation-triangle'></i>
        </CheckBox>
      </div>

      <Modal isOpen={modalUrgente} toggle={toggle}>
        <ModalHeader toggle={toggle}>     
          {messages['dashboards.examDetails.changeOfUrgency']}
        </ModalHeader>
        <ModalBody>
          <Label>{messages['dashboards.examDetails.justification']}</Label>
          <Input
            type='text'
            style={{ fontSize: '15px' }}
            onChange={e => setJustificativa(e.currentTarget.value)}
            value={justificativa}
            maxLength={250}
          />
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={toggle}>
            {messages['dashboards.examDetails.cancel']}
          </Button>
          <Button
            color='primary'
            onClick={() => marcarUrgente(justificativa)}
            disabled={!justificativa || justificativa === ''}
          >
            {messages['dashboards.examDetails.confirm']}
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default injectIntl (CheckUrgente);



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/CheckUrgente/index.js